import { render, staticRenderFns } from "./CatalogSlider.vue?vue&type=template&id=6ea37dc6"
import script from "./CatalogSlider.vue?vue&type=script&lang=js"
export * from "./CatalogSlider.vue?vue&type=script&lang=js"
import style0 from "./CatalogSlider.vue?vue&type=style&index=0&id=6ea37dc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports